export default function ValuePlaceholder() {
  return (
    <span
      className="inline-flex items-center px-2 py-0 rounded-md bg-gray-100 text-gray-800"
    >
      --
    </span>
  );
}
